export function markFormSubmitted(form: HTMLFormElement, message: string) {

	form.scrollIntoView({
		behavior: 'smooth',
		block: 'start',
	})

	let submitted = form.querySelector<HTMLElement>('[data-form="submitted"]');
	if (submitted) {
		submitted.innerText = message;
		submitted.classList.add('state-visible');
	}

}
